import React, { useContext } from "react";
import { Input } from "antd";
import Form from "antd/lib/form/Form";
import { ImplementerProfileFormContext } from "../../ImplementerProfileFormContext";

export const InteriorNumberInput = (props: any) => {
  const implementerAccountContext = useContext(ImplementerProfileFormContext);
  const {
    form,
    isBusy,
    onFieldsChange,
    implementerProfile
  } = implementerAccountContext;
  const { getFieldDecorator } = form;

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onFieldsChange({
      key: event.target.name,
      value: event.target.value
    });
  };

  return (
    <Form.Item label="Número interior">
      {getFieldDecorator("interiorNumber", {
        initialValue: implementerProfile?.interiorNumber
      })(
        <Input
          disabled={isBusy}
          id="interiorNumber"
          name="interiorNumber"
          placeholder="Número interior"
          onChange={onChange}
          size="large" />
      )}
    </Form.Item>
  );
};
